<ng-container *transloco="let t">
    <avatar-list (selectionChanged)="onSelectContact($event)" [appearance]="appearance" [availableElements]="_contacts"
        [customerID]="_customerID" [enabled]="_enabled" [matTooltipDisabled]="_enabled" [matTooltipPosition]="'above'"
        [placeholder]="t('General-CONTACTS')" [staticAvatar]="_staticAvatar" [type]="'contact'"
        matTooltip="{{t('Quotation-PLEASE-SELECT-A-CUSTOMER')}}"></avatar-list>
</ng-container>